
import * as _ from 'lodash'
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as AGChannel from "ag-channel"
import * as scClient from "socketcluster-client"

const bDebug = true

//-- Not much here, just need to multiplex all communication on a single client socket

export class PAWebSocketClient {

  private static scClientSocket: scClient.AGClientSocket = undefined

  private static async getAGClientSocket(): Promise<scClient.AGClientSocket> {

    if(!_.isUndefined(PAWebSocketClient.scClientSocket)){
      return PAWebSocketClient.scClientSocket
    }

    let opts: any = PAEnvironment.getValue(PAEnvironment.WebSocketCreate, {});
    if(bDebug)
      console.log("Websocket create options: ", opts)

    let clientSocket = scClient.create(opts)
    PAWebSocketClient.scClientSocket = clientSocket
    clientSocket.connect()

    return clientSocket
  }


  constructor() {

  }


  async getChannel(channelId: string): Promise<AGChannel<any>> {

    let ws = await PAWebSocketClient.getAGClientSocket()
    return ws.channel(channelId)
  }

  async invoke(command: string, msg: any, options?: {ackTimeout?: number}): Promise<any> {

    let ws = await PAWebSocketClient.getAGClientSocket()
    return await ws.invoke(command, msg, options)
  }

  async transmit(event: string, msg: any, options?: {ackTimeout?: number}): Promise<void> {

    let ws = await PAWebSocketClient.getAGClientSocket()
    await ws.transmit(event, event, options)

  }




}
